import type { IUser } from 'Model/index.js'
import { useSelector } from 'Flux/index.js'
import { createSelector } from '@reduxjs/toolkit'
import type { State } from 'Flux/Slice/index.js'
import { organizationSlice } from 'Flux/Slice/Organization/OrganizationSlice.js'

export const useGetOrganizationMembersSelector: (organizationId: string) => IUser[] = (organizationId: string) => {
  return useSelector((state: typeof State) => getOrganizationMembers(state, organizationId))
}

export const useGetUserByIdSelector: (id: string) => IUser | undefined = (id: string) => {
  return useSelector((state: typeof State) => state[organizationSlice.name].users[id])
}

const selectOrganizationMembers = (state: typeof State) => state[organizationSlice.name].organizationMembers

export const getOrganizationMembers = createSelector(
  [selectOrganizationMembers, (_state: typeof State, organizationId: string) => organizationId],
  (organizationMembers, organizationId) => {
    return organizationMembers[organizationId] || []
  }
)
